/**
 * AppLoadingScreen — branded full-screen loading state used as the Suspense
 * fallback for lazy-loaded routes. Keeps users on a familiar surface during
 * route-chunk fetches instead of flashing a white page.
 *
 * Lightweight: only imports the BrandMark + a tiny CSS animation so the
 * screen itself doesn't add to the wait time it's trying to mask.
 */
import React from 'react';
import { BrandMark } from '../brand/BrandLogo';

export default function AppLoadingScreen() {
  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center text-slate-100"
      style={{
        background:
          'radial-gradient(900px 500px at 50% 30%, rgba(6,182,212,0.10), transparent 60%),' +
          '#0B1220',
      }}
    >
      <div className="relative">
        {/* Pulsing ring behind the mark */}
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-full"
          style={{
            boxShadow: '0 0 0 0 rgba(6,182,212,0.45)',
            animation: 'varuna-pulse 1.6s ease-out infinite',
          }}
        />
        <BrandMark size={56} tone="dark" />
      </div>
      <div className="mt-6 text-[11px] uppercase tracking-widest text-cyan-300/70 font-semibold">
        Preparing workspace…
      </div>
      <style>{`
        @keyframes varuna-pulse {
          0%   { box-shadow: 0 0 0 0    rgba(6,182,212,0.45); }
          70%  { box-shadow: 0 0 0 22px rgba(6,182,212,0);    }
          100% { box-shadow: 0 0 0 0    rgba(6,182,212,0);    }
        }
      `}</style>
    </div>
  );
}
